/**
 * Base Aggregate Root
 * 
 * Provides common functionality for all aggregates
 * Since @swoft/core AggregateRoot doesn't provide all methods we need
 */

export abstract class AggregateRootBase {
  protected version: number = 0;
  private uncommittedEvents: any[] = [];

  constructor(protected readonly id: string, version?: number) {
    this.version = version || 0;
  }

  getId(): string {
    return this.id;
  }

  getVersion(): number {
    return this.version;
  }

  protected incrementVersion(): void {
    this.version++;
  }

  protected addDomainEvent<T>(event: T): void {
    this.uncommittedEvents.push(event);
  }

  getUncommittedEvents(): any[] {
    return this.uncommittedEvents;
  }

  markEventsAsCommitted(): void {
    this.uncommittedEvents = [];
  }
}